import React from "react";
import classNames from "classnames";


export function SimpleGrid(props) {

    const internalClass = classNames("row my-0 p-0 w-100 " + props.className)

    if(props.children == null || props.children.length === 0 || props.rowSize == null) {
        return null;
    }

    const rows = [...Array(Math.ceil(props.children.length / props.rowSize)).keys()];

    const columnClass = classNames("col p-0 ", "m-"+props.margin, {
        'bg-white':props.useBackground,
        'rounded' :props.rounded
    });

    let remainingCols = props.rowSize-(props.children.length % props.rowSize);
    if(props.children.length === 1) {
        remainingCols = props.rowSize-1;
    }

    if(props.children.length % props.rowSize === 0) {
        remainingCols = 0;
    }
    const remaining = [...Array(remainingCols).keys()];

    if(rows.length > 0) {

        return (
            <>
                {
                    rows.map((idx,row) => (

                        <div className={internalClass} key={"simpleGridElement_"+idx}>
                            {props.children.slice(idx*props.rowSize, idx*props.rowSize+props.rowSize).map(child => (
                                <div className={columnClass} >
                                    {
                                        child
                                    }
                                </div>
                            ))}

                            {
                                idx === rows.length-1 && props.fill ?
                                    remaining.map(col => (
                                        <div className={columnClass}>

                                        </div>
                                    ))
                                    :
                                    null
                            }
                        </div>

                    ))
                }
            </>
        );
    }

}